export default [
  { header: 'Dashboard' },
  { href: '/', title: 'Dashboard Home', icon: 'home' },
  { href: '/email_alerts', title: 'Your E-mail Alerts', icon: 'notifications', count: true },
  { href: '/groups', title: 'Your Fund Groups', icon: 'group', count: true },
  { href: '/tracked_backtests', title: 'Your Tracked Backtests', icon: 'trending_up', count: true },
  { href: '/whale_trader', title: 'The WhaleTrader' },
  { href: '/insider_dashboard', title: 'Insider Dashboard' },
  { href: '/insider_backtester', title: 'Insider Backtester' },
  { href: '/analytics/backtester', title: '13F Backtester' },
  { href: '/search/fund_search', title: 'Fund Targeting Search', icon: 'my_location' },
  { header: 'Tools' },

  {
    title: '13F Analytics',
    group: '/analytics',
    icon: 'bar_chart',
    items: [
      { href: '/analytics/backtester', title: '13F Backtester' },
      { href: '/analytics/consensus', title: 'Consensus Holdings' },
      { href: '/analytics/combined', title: 'Combined Holdings' },
      { href: '/analytics/double_down', title: 'Double-Down Report' },
      { href: '/analytics/overlapping_matrix', title: 'Overlap Matrix' },
      { href: '/analytics/early_bird_screener', title: '"Early Bird" Screener' }
    ]
  },
  {
    title: '13F Search Tools',
    group: '/search',
    icon: 'search',
    items: [
      { href: '/search/fund_performance_search', title: '13F Fund Performance Search' },
      { href: '/search/options_search', title: '13F Options Search' },
      { href: '/search/stock_screener', title: '13F Stock Screener' },
      { href: '/search/sector_search', title: '13F Sector Search' }
    ]
  },
  {
    title: 'Other Dashboard Tools',
    group: '/other',
    icon: 'layers',
    items: [
      { href: '/other/schedule13', title: '13D/G Search' },
      { href: '/other/uk_search', title: 'UK Significant Shareholders' },
      { href: '/other/hkex_search', title: 'Hong Kong (HKEX) Significant Shareholders' },
      { href: '/other/form_adv_search', title: 'Advisor Search (Form Adv)' },
      { href: '/other/form_d_search', title: 'Form D Search' },
      { href: '/other/nsar_search', title: 'N-SAR Search' },
      { href: '/other/form4_search', title: 'Insider Transactions' }
    ]
  },
  {
    title: 'Mutual Fund Tools',
    group: '/mutual_fund',
    icon: 'layers',
    items: [
      { href: '/mutual_fund/ncen_search', title: 'Mutual Fund (N-CEN) Search' },
      { href: '/mutual_fund/combined_mutual_fund', title: 'Combined Mutual Fund Report' }
    ]
  },
  { header: 'Additional resources' },
  {
    title: 'Non Dashboard Pages',
    icon: 'list_alt',
    items: [
      { href: '/filing/latest_filings', title: 'Latest 13F Filings', external: true },
      { href: '/report/heat_map', title: '13F Heat Map', external: true },
      { href: '/info/excel_add_in', title: 'Excel Add-in', external: true },
      { href: '/statistics/trends', title: '13F Trend Charts', external: true },
      { href: '/info/statistics_tab', title: '13F Stats', external: true },
      { href: '/statistics/stock_statistics', title: '13F Stock Stats', external: true },
      { href: '/schedule13d', title: 'Latest 13D/G Filings', external: true },
      { href: '/ownership/index_by_day', title: 'Latest Insider Transactions', external: true },
      { href: '/whaleindex', title: 'WhaleIndex', external: true },
      { href: '/whaleindex/index/micro_small_mid', title: 'WhaleIndex Mid/Small/Micro', external: true },
      { href: '/info/subscription_info', title: 'Pricing', icon: 'credit_card', external: true }
    ]
  },
  {
    title: 'Site Help',
    icon: 'help_outline',
    items: [
      { href: '/whitepapers/whalewisdom', title: 'How Can WhaleWisdom Help You', external: true },
      { href: '/whitepapers/backtesting', title: 'Backtesting White Paper', external: true },
      { href: '/info/getting_started', title: 'Getting Started', external: true },
      { href: '/info/tutorial_videos', title: 'Video Tutorials', external: true },
      { href: '/info/faq', title: 'FAQ', external: true },
      { href: '/info/investing_13f', title: 'Whale University', external: true },
      { href: '/info/about', title: 'About', external: true },
      { href: '/articles', title: 'Blog and News', external: true },
      { href: '/info/contact', title: 'Contact Us', external: true }
    ]
  }
]
